import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import ErrorMsg from "../../components/form/errorMsg";
import { useNavigate } from "react-router-dom";
import back from "../../assets/back.svg";
import { useDispatch } from "react-redux";
import { supportCreate } from "../../redux/actions/settingAction";
import ChangeSaved from "../../components/popups/ChangeSaved";
import ErrorPopup from "../../components/popups/ErrorPopup";

const Support = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [onSuccessShow, onSetSuccessShow] = useState(false);
  const [onSuccessMsg, onSetSuccessMsg] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");

  const initialValues = {
    title: "",
    description: "",
  };
  const loginSchema = Yup.object().shape({
    title: Yup.string().trim().required("* Required"),
    description: Yup.string().trim().required("* Required"),
  });
  const onSubmit = (values, { resetForm }) => {
    dispatch(supportCreate(values, onSuccess, onError));
    resetForm();
  };

  const timeOutFnc = () => {
    onSetSuccessShow(false);
  }

  const onSuccess = (data) => {
    console.log(data);
    onSetSuccessShow(true);
    const str = (data.data.message);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    onSetSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  }

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = (err.data.message);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <>
      <div
        className="d-flex align-items-center p-2 mx-5 my-2 m-1 mb-2 cursor_pointer"
        onClick={() => navigate(-1)}
      >
        <img src={back} alt="back_btn" />
        <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
          BACK
        </span>
      </div>
      <div className="d-flex justify-content-center align-items-center fn_Nunito col-12 my-auto ">
        <div className="support-main-container col-10 col-md-8  px-4 py-4 my-auto ">
          <label className="fs_22 fs_sm_20 fw_700">Support</label>
          <label className="color_747f9e fs_14">
            Kindly share the issue you are facing and our team will get back to you as early as possible.
          </label>

          <Formik
            initialValues={initialValues}
            validationSchema={loginSchema}
            onSubmit={onSubmit}
          >
            {(props) => (
              <Form>
                <div className="mt-4 pt-2">
                  <div className="">
                    <label className="fs_14 color_262c3d ">
                      Title of issue
                    </label>
                    {/* <input
              type="text"
              id="Title"
              name=""
              className="w-100  p-2"
              placeholder=""
            /> */}
                    <Field name={"title"}>
                      {({ field, meta }) => (
                        <input
                          {...field}
                          placeholder="Enter title of issue"
                          id={"title"}
                          className={"w-100 support-input  p-2"}
                        />
                      )}
                    </Field>
                    <ErrorMsg name="title" />
                  </div>
                  <div className="">
                    <label className="mt-3 fs_14 color_262c3d">Issue</label>
                    <div>
                      <Field name={"description"}>
                        {({ field, meta }) => (
                          <textarea
                            {...field}
                            id="description"
                            name="description"
                            className="support-text-area p-2 w-100"
                            placeholder="Write an issue you have"
                            rows={6}
                          ></textarea>
                        )}
                      </Field>
                      <ErrorMsg name="description" />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  className="support-submit-btn w-100 text-white py-2 fs_14 fs_sm_12 mt-3"
                >
                  submit
                </button>
              </Form>
            )}
          </Formik>
          <ChangeSaved
            show={onSuccessShow}
            title={onSuccessMsg}
          />
          <ErrorPopup
            show={showErrorPopup}
            title={showErrorMsg}
            handleClose={closeErrorPopup}
          />
        </div>
      </div>
    </>
  );
};

export default Support;
